import {ViewOrGetQuotesPage} from "./ViewOrGetQuotesPage";
import {authorize} from "@athena-portal/components";

@authorize
export class CustomerViewOrGetQuotesPage extends ViewOrGetQuotesPage {

    constructor(props: Readonly<{}>) {
        super(props);
        super.setState({isCustomer: true});
    }
}
